export default __webpack_public_path__ + "b245dc0404a78ec95679a0569614354a.svg";